export const GOOGLE_MAPS_API_KEY =
  process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ||
  process.env.REACT_APP_API_MAPS ||
  'AIzaSyBZnK6XVqQbxVy6SJlIuuV1o69nH8xQLTQ';

